import { useEffect, useState } from 'react'
import { Box, Fade, Modal } from '@mui/material';
import { BsXCircle } from "react-icons/bs"
import { RadioGroup } from '@headlessui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { findProductsById } from '../../state/Product/Action'
import { addItemToCart } from '../../state/Cart/Action'
import CarouselFull from '../Carousel/CarouselFull';
import Helmet from '../../helmet/Helmet';
import { IMAGES_URL } from "../../config/apiConfig";
function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
export default function ProductDetails() {

  const [_title, _setTitle] = useState('Thương hiệu thời trang Việt Nam.')
  const [selectedColor, setSelectedColor] = useState()
  const [selectedSize, setSelectedSize] = useState()
  const [_index, _setIndex] = useState(0)
  const [_colors, _setColors] = useState([])
  const [_sizes, _setSizes] = useState([])
  const [_products, _setProducts] = useState([])
  const [_productFull, _setProductFull] = useState([]);
  const [showKichThuoc, setShowKichThuoc] = useState(true);
  const [_kichThuocData, _setKichThuocData] = useState([])
  const [sizeGuide, setSizeGuide] = useState([]);

  const toggleKichThuoc = () => {
    setShowKichThuoc(prev => !prev);
  };

  // Tách các size duy nhất (S, M, L,...)
  //  const uniqueSizes = [...new Set(_kichThuocData?.map(item => item.Size))];
  //const uniqueSizes = Object.keys(sizeGuide[0].values); // ["S - 02", "M - 04", ...]
  //const uniqueSizes = sizeGuide.length > 0 ? Object.keys(sizeGuide[0].values) : [];
  // Lấy danh sách mã size khả dụng (trimming phòng trường hợp thừa dấu cách)
  const availableSizeCodes = _sizes.map(sz => (sz.MaSize ?? "").trim());
  // Chỉ lấy những size nằm trong _sizes
  const uniqueSizes = sizeGuide.length > 0
    ? Object.keys(sizeGuide[0].values).filter(sz => availableSizeCodes.includes(sz.trim()))
    : [];




  // Gom nhóm theo khu vực
  const groupedByKhuVuc = _kichThuocData?.reduce((acc, item) => {
    if (!acc[item.KhuVuc]) acc[item.KhuVuc] = {};
    acc[item.KhuVuc][item.Size] = item.Value;
    return acc;
  }, {});


  const navigate = useNavigate();
  const dispatch = useDispatch();
  const param = useParams();
  const xoadautiengviet = (str = "") => {
    const map = {
      à: "a", á: "a", ạ: "a", ả: "a", ã: "a", â: "a", ầ: "a", ấ: "a", ậ: "a", ẩ: "a", ẫ: "a", ă: "a", ằ: "a", ắ: "a", ặ: "a", ẳ: "a", ẵ: "a",
      è: "e", é: "e", ẹ: "e", ẻ: "e", ẽ: "e", ê: "e", ề: "e", ế: "e", ệ: "e", ể: "e", ễ: "e",
      ì: "i", í: "i", ị: "i", ỉ: "i", ĩ: "i",
      ò: "o", ó: "o", ọ: "o", ỏ: "o", õ: "o", ô: "o", ồ: "o", ố: "o", ộ: "o", ổ: "o", ỗ: "o", ơ: "o", ờ: "o", ớ: "o", ợ: "o", ở: "o", ỡ: "o",
      ù: "u", ú: "u", ụ: "u", ủ: "u", ũ: "u", ư: "u", ừ: "u", ứ: "u", ự: "u", ử: "u", ữ: "u",
      ỳ: "y", ý: "y", ỵ: "y", ỷ: "y", ỹ: "y",
      đ: "d"
    };
    return str.toLowerCase().replace(/[àáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđ]/g, match => map[match] || "").replace(/[^0-9a-z-\s]/g, "").replace(/\s+/g, "-").replace(/^-+|-+$/g, "");
  };
  useEffect(() => {
    const fetchData = async () => {
      const data = { productId: param.productId };
      const res = await dispatch(findProductsById(data));

      if (!res) return;
      if (res.sizeGuide) setSizeGuide(res.sizeGuide);

      _setKichThuocData(res.sizesall);
      _setProductFull(res);
      if (Array.isArray(res.sizes) && res.sizes.length > 0) {
        const processedColors = res.sizes.reduce((acc, item) => {
          if (!acc[item.MaMau]) {
            acc[item.MaMau] = { ...item, QuanLy: false };
          }
          if (item.QuanLy) {
            acc[item.MaMau].QuanLy = true;
          }
          return acc;
        }, {});
        _setColors(Object.values(processedColors));
        setSelectedColor(Object.values(processedColors)[0] || null);
      }
    };

    fetchData();
  }, [param.productId]);

  useEffect(() => {
    if (!_productFull.sizes || _productFull.sizes.length === 0) return;

    const sizesForColor = _productFull.sizes.filter(size => size.MaMau === selectedColor?.MaMau);
    _setSizes(sizesForColor);

    // Chọn size đầu tiên có thể chọn nếu có
    const firstAvailableSize = sizesForColor.find(size => size.QuanLy);
    setSelectedSize(firstAvailableSize ? firstAvailableSize.MaSize : null);
  }, [selectedColor, _productFull.sizes]);
  const VND = new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  });
  const handleAddToCart = () => {
    if (!selectedColor || !selectedSize) return;

    const data = {
      productId: param.productId,
      productName: _productFull.product?.tenSanPham || "",
      color: selectedColor?.MaMau || "",
      colorName: selectedColor?.TenMau || "",
      size: selectedSize || "",
      quantity: 1,
      unitPrice: _productFull.product?.donGia || 0
    };

    dispatch(addItemToCart(data)).then(() => handleOpen());
  };

  const handleBuyNow = () => {
    const data = { productId: param.productId, productName: _productFull.product?.tenSanPham, color: selectedColor.MaMau, colorName: selectedColor.TenMau, size: selectedSize, quantity: 1, unitPrice: _productFull.product?.donGia }
    dispatch(addItemToCart(data)).then(
    )
    navigate("/gio-hang.html")
  }
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid blue',
    boxShadow: 24,
    p: 4,
  };
  const [open, setOpen] = useState(false);
  const [timer, setTimer] = useState(null);
  const handleOpen = () => {
    setOpen(true);
    if (timer) clearTimeout(timer);
    setTimer(setTimeout(() => setOpen(false), 1000));
  };

  const handleClose = () => {
    setOpen(false);
    timer && clearTimeout(timer);
  };
  const [openimage, setOpenimage] = useState(false);
  const handleOpenimage = (index) => {
    _setIndex(index);
    setOpenimage(true);
  };
  const handleCloseimage = () => { setOpenimage(false); };
  return (

    <Helmet title={_title}>
      <div className=' pt-20 mx-auto px-4 sm:px-6 lg:px-8'>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{}}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <span id="transition-modal-description" sx={{ mt: 2 }}>
                Bạn đã thêm sản phẩm vào giỏ.
              </span>
            </Box>
          </Fade>
        </Modal>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={openimage}
          onClose={handleCloseimage}
          closeAfterTransition
          slots={{}}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          {/* sm:w-[200px] md:w-[500px] lg:w-[560px] */}
          <Fade in={openimage}>


            {/* sm:w-[200px] md:w-[270px] lg:w-[620px] */}
            <div className=' flex justify-center h-[svh] relative bg-slate-600'>
              <Box className=" absolute sm:w-[200px] md:w-[270px] lg:w-[620px]"  >
                <div className=' absolute w-full pr-6 pt-2 justify-end items-end flex text-gray-400 z-10 text-3xl'>
                  <button onClick={handleCloseimage}>
                    <BsXCircle />
                  </button>
                </div>
                <CarouselFull slides={_productFull.imagesByColor?.[selectedColor?.MaMau]} index={_index} />
              </Box>
            </div>

          </Fade>
        </Modal>
        <nav aria-label="Breadcrumb">
          <ol role="list" className="mx-auto flex max-w-2xl items-center space-x-2 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
            <li key={_productFull.product?.maNhomSanPham}>
              <div className="flex items-center">
                <a href={`${_productFull.product?.maNhomSanPham === '102' ? '/nu/tat-ca-san-pham-nu.html' : _productFull.product?.maNhomSanPham === '101' ? '/nam/tat-ca-san-pham-nam.html' : '/phu-kien/tat-ca-phu-kien.html'}`} className="mr-2 text-sm font-medium text-gray-900">
                  {_productFull.product?.tenNhomSanPham}
                </a>
                <svg
                  width={16}
                  height={20}
                  viewBox="0 0 16 20"
                  fill="currentColor"
                  aria-hidden="true"
                  className="h-5 w-4 text-gray-300"
                >
                  <path d="M5.697 4.34L8.98 16.532h1.327L7.025 4.341H5.697z" />
                </svg>
              </div>
            </li>
            <li key={_productFull.product?.loaiSanPham}>
              <div className="flex items-center">
                <a href={'/' + xoadautiengviet(_productFull.product?.tenNhomSanPham) + '/' + xoadautiengviet(_productFull.product?.tenLoaiSanPham) + '.html'} className="mr-2 text-sm font-medium text-gray-900">
                  {_productFull.product?.tenLoaiSanPham}
                </a>
                <svg
                  width={16}
                  height={20}
                  viewBox="0 0 16 20"
                  fill="currentColor"
                  aria-hidden="true"
                  className="h-5 w-4 text-gray-300"
                >
                  <path d="M5.697 4.34L8.98 16.532h1.327L7.025 4.341H5.697z" />
                </svg>
              </div>
            </li>
            <li className="text-sm">
              <span aria-current="page" className="font-medium text-gray-500 hover:text-gray-600">
                {_productFull.product?.maSanPham}
              </span>
            </li>
          </ol>
        </nav>
        <section aria-labelledby="products-heading" className="pb-6 pt-6">
          <div className="grid grid-cols-1 gap-x-3 gap-y-1 lg:grid-cols-6 pb-3">
            <div className="lg:col-span-4 w-full p-0 m-0 ">

              <div className='  gap-x-1 gap-y-1 flex flex-wrap justify-center'>

                {_productFull.imagesByColor?.[selectedColor?.MaMau]?.length > 0 ? (
                  _productFull.imagesByColor[selectedColor?.MaMau].map((item, index) => (
                    <a key={index} className="group" onClick={() => { _setIndex(index); setOpenimage(true); }}>
                      <div className={`overflow-hidden rounded-lg bg-gray-200 ${_productFull.imagesByColor[selectedColor?.MaMau].length === 1 ? 'lg:max-w-[700px] md:max-w-[400px]' : 'md:max-w-[300px] lg:max-w-[400px] xl:max-w-[430px]'}`}>
                        <img
                          src={item}
                          alt={_productFull.product?.tenSanPham}
                          className="h-full w-full object-cover object-center group-hover:opacity-75"
                          onError={(e) => e.target.style.display = 'none'}
                        />
                      </div>
                    </a>
                  ))
                ) : null}


              </div>

            </div>
            <div className='lg:col-span-2' >
              {/* Options */}
              <div className="mt-4 lg:row-span-3 lg:mt-0">
                <h2 className="sr-only">Thông tin sản phẩm</h2>
                <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">{_productFull.product?.tenSanPham}</h1>
                <span>Mã SP: {_productFull.product?.maSanPham}</span>
                <p className="text-3xl tracking-tight text-gray-900">{VND.format(_productFull.product?.donGia * 1000)}</p>
                <div className='pt-5 pl-5  gap-x-1 gap-y-1  ' dangerouslySetInnerHTML={{ __html: _productFull.product?.mota }}></div>
                <form className="mt-10">
                  {/* Colors */}
                  <div>
                    <h3 className="text-sm font-medium text-gray-900">{selectedColor?.TenMau}</h3>

                    <RadioGroup value={selectedColor} onChange={setSelectedColor} className="mt-4">
                      <RadioGroup.Label className="sr-only">Chọn màu</RadioGroup.Label>
                      <div className="flex items-center space-x-1 space-y-1 flex-wrap">
                        {_colors?.map((color) => (
                          <div key={color.MaMau}>
                            <RadioGroup.Option
                              value={color}
                              disabled={!color.QuanLy}
                              className={({ active, checked }) =>
                                classNames(
                                  color.selectedClass || "", // Đảm bảo không bị lỗi undefined
                                  active && checked ? "ring ring-offset-1" : "",
                                  !active && checked ? "ring-2" : "",
                                  "relative -m-0.5 flex cursor-pointer items-center justify-center p-0.5 focus:outline-none"
                                )
                              }
                            >
                              <img
                                src={`${IMAGES_URL}${_productFull.product?.maSanPham.trim()}-${color.MaMau}-00.jpg`}
                                alt={_productFull.product?.tenSanPham}
                                className="w-[2.5rem] h-[3rem]"
                              />
                              <RadioGroup.Label as="span" className="sr-only">
                                {color.TenMau}
                              </RadioGroup.Label>
                            </RadioGroup.Option>
                          </div>
                        ))}
                      </div>
                    </RadioGroup>
                  </div>
                  {/* Sizes */}
                  <div className="mt-10">
                    {

                      ((_productFull.product?.maSize ?? "").trim() === "FS") ? "" : (

                        <div>
                          <div className="flex items-center justify-between">
                            <h3 className="text-sm font-medium text-gray-900">Kích cỡ</h3>
                          </div>

                          <RadioGroup value={selectedSize} onChange={setSelectedSize} className="mt-4">
                            <RadioGroup.Label className="sr-only">Chọn kích cỡ</RadioGroup.Label>
                            <div className="justify-start flex flex-wrap space-x-2 max-h-40">
                              {_sizes.length > 0 ? (
                                _sizes.map((size) => (
                                  <div key={size.MaSize.trim()}>
                                    <RadioGroup.Option
                                      value={size.MaSize.trim()}
                                      disabled={!size.QuanLy}
                                      className={({ active }) =>
                                        classNames(
                                          size.QuanLy
                                            ? "cursor-pointer bg-white text-gray-900 shadow-sm"
                                            : "cursor-not-allowed bg-gray-50 text-gray-200",
                                          active ? "ring-2 ring-indigo-500" : "",
                                          "group relative flex items-center justify-center rounded-md border px-5 py-5 max-h-[3rem] max-w-[3rem] text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 sm:py-6"
                                        )
                                      }
                                    >
                                      {({ active, checked }) => (
                                        <>
                                          <RadioGroup.Label as="span">{size.MaSize.trim()}</RadioGroup.Label>
                                          {size.QuanLy ? (
                                            <span
                                              className={classNames(
                                                active ? "border" : "border-2",
                                                checked ? "border-indigo-500" : "border-transparent",
                                                "pointer-events-none absolute -inset-px rounded-md"
                                              )}
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <span
                                              aria-hidden="true"
                                              className="pointer-events-none absolute -inset-px rounded-md border-2 border-gray-200"
                                            >
                                              <svg
                                                className="absolute inset-0 h-full w-full stroke-2 text-gray-200"
                                                viewBox="0 0 100 100"
                                                preserveAspectRatio="none"
                                                stroke="currentColor"
                                              >
                                                <line x1={0} y1={100} x2={100} y2={0} vectorEffect="non-scaling-stroke" />
                                              </svg>
                                            </span>
                                          )}
                                        </>
                                      )}
                                    </RadioGroup.Option>
                                  </div>
                                ))
                              ) : (
                                <p className="text-gray-500 text-sm">Không có size cho màu này</p>
                              )}
                            </div>
                          </RadioGroup>
                        </div>)}

                  </div>
                  {/* <a href='/size'>Bảng size</a> */}


                  <div className="w-full">
                    {/* Nút hiển thị/ẩn */}
                    <div className="pt-10 justify-end text-right">
                      <a
                        href='/huong-dan-su-dung'
                        className="cursor-pointer text-blue-600 underline"
                      >
                        Hướng dẫn sử dụng
                      </a>
                    </div>
                    <div className="pt-2 justify-end text-right">
                      <a
                        onClick={toggleKichThuoc}
                        className="cursor-pointer text-blue-600 underline"
                      >
                        Kích thước sản phẩm {showKichThuoc ? '−' : '+'}
                      </a>
                    </div>

                    {/* Nội dung kích thước */}

                    {showKichThuoc && (
                      <div id="Kichthuoc" className="mt-4 bg-gray-100 p-4 rounded shadow">


                        {uniqueSizes.length > 0 ? (
                          <>
                            <p className="font-semibold text-lg mb-2">Kích thước sản phẩm</p>
                            <span className="block mb-4 text-sm text-gray-700">
                              Các số đo có thể sai số nhỏ do quá trình sản xuất. Sản phẩm được đo khi trải phẳng.
                            </span>
                            <img
                              src={
                                _productFull.product?.sizeGroupID
                                  ? `${IMAGES_URL}${_productFull.product.sizeGroupID}-SZ.jpg`
                                  : ""
                              }
                              alt="Kích thước sản phẩm"
                              className="max-w-full h-auto mx-auto"
                            />
                            <div className="overflow-x-auto mt-4">
                              <table className="min-w-max w-full table-auto border-collapse text-left">

                                <thead>
                                  <tr className="border-b border-gray-300">
                                    <th className="py-2 px-3 font-semibold">SIZE</th>
                                    {uniqueSizes.map((size) => (
                                      <th key={size} className="py-2 px-3 font-semibold text-center">{size}</th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  {sizeGuide.map((row) => (
                                    <tr key={row.label} className="border-b border-gray-200">
                                      <td className="py-2 px-3 font-semibold">{row.label}</td>
                                      {uniqueSizes.map((size) => (
                                        <td key={size} className="py-2 px-3 text-center">
                                          {row.values[size] ?? "-"}
                                        </td>
                                      ))}
                                    </tr>
                                  ))}
                                </tbody>
                                

                              </table>
                            </div>





                          </>
                        ) : (
                          <div className="text-center text-sm text-gray-600 mt-4">
                            <div className="text-2xl mb-2"></div> {/* icon treo đồ */}
                            <p className="font-semibold">BẢNG HƯỚNG DẪN CHỌN CỠ HIỆN KHÔNG CÓ</p>
                            <p> PT2000 đang cập nhật thông tin về cỡ của sản phẩm này</p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className=' flex justify-between pt-3 mt-5'>
                    <button
                      onClick={handleAddToCart}
                      type="button"
                      className="flex w-[49%] items-center justify-center rounded-md border border-transparent bg-indigo-600 px-8 py-3 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      Thêm vào giỏ
                    </button>
                    <button
                      onClick={handleBuyNow}
                      type="button"
                      className="w-[50%] items-center justify-center rounded-md border border-transparent bg-indigo-600 px-8 py-3 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      Mua Ngay
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <hr />
        </section>
        <span className=' text-2xl' >Sản phẩm cùng loại</span>
        <section className=' pt-10 pb-10'>
          <div className=" grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-2 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 xl:gap-x-8">
            {_productFull?.productSame?.map((product) => (

              <a key={product.maSanPham} href={`/san-pham/` + product.maSanPham + `.html`} className="group">
                <div className="k_img overflow-hidden rounded-lg bg-gray-200 ">
                  <img
                    src={IMAGES_URL + product.maSanPham.trim() + "-00.jpg"}
                    alt={product.tenSanPham}
                    className="h-full w-full object-cover object-center group-hover:opacity-75"
                    onError={i => i.target.style.display = 'none'}
                  />
                </div>
                <h3 className="mt-4 text-sm text-gray-700">{product.tenSanPham} {'(' + product.maSanPham + ')'}</h3>

                <p className="mt-1 text-md font-medium text-gray-900">{VND.format(product.donGia)}</p>
              </a>

            ))}
          </div>

        </section>
      </div>
    </Helmet>
  )
}
